import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DynamicUnderline',
  props: {
    targetWidth: null,
    targetXPosition: null
  },
  setup(__props: any) {

const props = __props as {
    targetWidth: number,
    targetXPosition: number,
}



const dynamicUnderlineWidthAndPosition = computed(() => {
    return {
        'max-width': `${props.targetWidth}px`,
        transform: `translateX(${props.targetXPosition}px)`,
    };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "aria-hidden": "true",
    class: "dynamic-underline",
    style: _normalizeStyle(_unref(dynamicUnderlineWidthAndPosition))
  }, null, 4))
}
}

})